import { render, staticRenderFns } from "./OrdersTableDetailsCell.vue?vue&type=template&id=58474e6a&scoped=true&"
import script from "./OrdersTableDetailsCell.vue?vue&type=script&lang=js&"
export * from "./OrdersTableDetailsCell.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTableDetailsCell.vue?vue&type=style&index=0&id=58474e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58474e6a",
  null
  
)

export default component.exports